export const enum JourneyStatus {
  NEEDS_SOURCE = 'NEEDS_SOURCE',

  NEEDS_DESTINATION = 'NEEDS_DESTINATION',

  NEEDS_DRIVER = 'NEEDS_DRIVER',

  NEEDS_VEHICLE_TYPE = 'NEEDS_VEHICLE_TYPE',

  AWAITING_PICKUP = 'AWAITING_PICKUP',

  AWAITING_DROP_OFF = 'AWAITING_DROP_OFF',

  COMPLETE = 'COMPLETE',

  CANCELED = 'CANCELED',
}
